module.exports = "/lucky-balls/img/drum/drum_loop_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_015.png
// module id = 1030
// module chunks = 0